// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimV1TypesProcessorsCodeProcessorsResponse {
    static getAttributeTypeMap() {
        return ClaimV1TypesProcessorsCodeProcessorsResponse.attributeTypeMap;
    }
}
ClaimV1TypesProcessorsCodeProcessorsResponse.discriminator = undefined;
ClaimV1TypesProcessorsCodeProcessorsResponse.additionalProperties = false;
ClaimV1TypesProcessorsCodeProcessorsResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<ClaimLookupModel>"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
];
//# sourceMappingURL=claimV1TypesProcessorsCodeProcessorsResponse.js.map